module.exports = __webpack_public_path__ + "media/images/icons/form_professional_step_1-4c8b77300951b54d6d79714937fb0e3b.svg";